export const USUARIO_PERFIL_LISTAR_BEGIN = 'USUARIO_PERFIL_LISTAR_BEGIN';
export const USUARIO_PERFIL_LISTAR_SUCCESS = 'USUARIO_PERFIL_LISTAR_SUCCESS';
export const USUARIO_PERFIL_LISTAR_FAILURE = 'USUARIO_PERFIL_LISTAR_FAILURE';
export const USUARIO_PERFIL_LISTAR_DISMISS_ERROR = 'USUARIO_PERFIL_LISTAR_DISMISS_ERROR';
export const USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN = 'USUARIO_PERFIL_LISTAR_ATIVOS_BEGIN';
export const USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS = 'USUARIO_PERFIL_LISTAR_ATIVOS_SUCCESS';
export const USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE = 'USUARIO_PERFIL_LISTAR_ATIVOS_FAILURE';
export const USUARIO_PERFIL_LISTAR_ATIVOS_DISMISS_ERROR = 'USUARIO_PERFIL_LISTAR_ATIVOS_DISMISS_ERROR';
export const USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN = 'USUARIO_PERFIL_BUSCAR_POR_ID_BEGIN';
export const USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS = 'USUARIO_PERFIL_BUSCAR_POR_ID_SUCCESS';
export const USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE = 'USUARIO_PERFIL_BUSCAR_POR_ID_FAILURE';
export const USUARIO_PERFIL_BUSCAR_POR_ID_DISMISS_ERROR = 'USUARIO_PERFIL_BUSCAR_POR_ID_DISMISS_ERROR';
export const USUARIO_PERFIL_SALVAR_BEGIN = 'USUARIO_PERFIL_SALVAR_BEGIN';
export const USUARIO_PERFIL_SALVAR_SUCCESS = 'USUARIO_PERFIL_SALVAR_SUCCESS';
export const USUARIO_PERFIL_SALVAR_FAILURE = 'USUARIO_PERFIL_SALVAR_FAILURE';
export const USUARIO_PERFIL_SALVAR_DISMISS_ERROR = 'USUARIO_PERFIL_SALVAR_DISMISS_ERROR';
export const USUARIO_PERFIL_DELETAR_BEGIN = 'USUARIO_PERFIL_DELETAR_BEGIN';
export const USUARIO_PERFIL_DELETAR_SUCCESS = 'USUARIO_PERFIL_DELETAR_SUCCESS';
export const USUARIO_PERFIL_DELETAR_FAILURE = 'USUARIO_PERFIL_DELETAR_FAILURE';
export const USUARIO_PERFIL_DELETAR_DISMISS_ERROR = 'USUARIO_PERFIL_DELETAR_DISMISS_ERROR';
export const USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN = 'USUARIO_PERFIL_DELETAR_REGISTRO_BEGIN';
export const USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS = 'USUARIO_PERFIL_DELETAR_REGISTRO_SUCCESS';
export const USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE = 'USUARIO_PERFIL_DELETAR_REGISTRO_FAILURE';
export const USUARIO_PERFIL_DELETAR_REGISTRO_DISMISS_ERROR = 'USUARIO_PERFIL_DELETAR_REGISTRO_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/constants.js